import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import MarkedReact from 'marked-react';
export const Markdown = ({
  children
}) => {
  return _jsx(MarkedReact, {
    isInline: true,
    value: children
  });
};